import React, { useState, useEffect, useRef } from "react";
import { MessageSquare } from "lucide-react";
import botResponses from "./chatbotData";

export default function Chatbot() {
  const [open, setOpen] = useState(false);
  const [messages, setMessages] = useState([
    {
      from: "bot",
      text: "Hola 👋, soy tu asistente virtual. Pregunta por horarios, servicios o ubicaciones.",
    },
  ]);
  const [input, setInput] = useState("");
  const endRef = useRef(null);

  useEffect(() => {
    endRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  function onSubmit(e) {
    e.preventDefault();
    if (!input.trim()) return;

    const user = input.trim();
    setMessages((m) => [...m, { from: "user", text: user }]);
    setInput("");

    const lower = user.toLowerCase();
    let found = botResponses.find((p) =>
      p.triggers.some((t) => lower.includes(t))
    );

    const reply = found
      ? found.reply
      : "No entendí 😅. Prueba con: horarios, ubicaciones, servicios o precios.";

    setTimeout(
      () => setMessages((m) => [...m, { from: "bot", text: reply }]),
      400
    );
  }

  return (
    <div className="fixed bottom-5 right-5 z-50">
      {open ? (
        <div className="w-80 bg-white rounded-2xl shadow-xl border border-gray-200 p-3 animate-fadeIn">
          <div className="flex items-center justify-between">
            <div className="font-semibold text-blue-700">Asistente Virtual</div>
            <button
              onClick={() => setOpen(false)}
              className="text-sm text-gray-500 hover:text-black"
            >
              Cerrar
            </button>
          </div>

          <div className="h-60 overflow-auto mt-2 space-y-2 bg-gray-50 rounded p-2">
            {messages.map((m, i) => (
              <div
                key={i}
                className={`p-2 rounded text-sm ${
                  m.from === "bot"
                    ? "bg-white shadow-sm"
                    : "bg-blue-100 text-blue-800"
                }`}
              >
                {m.text}
              </div>
            ))}
            <div ref={endRef}></div>
          </div>

          <form onSubmit={onSubmit} className="mt-2 flex gap-2">
            <input
              className="flex-1 border rounded p-2 text-sm"
              placeholder="Escribe..."
              value={input}
              onChange={(e) => setInput(e.target.value)}
            />
            <button className="px-3 py-2 bg-blue-600 text-white rounded shadow hover:bg-blue-700">
              Enviar
            </button>
          </form>
        </div>
      ) : (
        <button
          onClick={() => setOpen(true)}
          className="p-4 rounded-full bg-blue-600 text-white shadow-xl hover:bg-blue-700 transition"
        >
          {/* ICONO MÁS GRANDE (DE 18 → 32) */}
          <MessageSquare size={32} />
        </button>
      )}
    </div>
  );
}
